import { motion } from "framer-motion";
import { Check, Shield } from "lucide-react";
import { TEST_IDS } from "@/constants/testIds";

const lines = [
  { label: "Couple Reset — 60-minute session", value: "₹3,999" },
  { label: "GST (5%)", value: "₹199.95" },
  { label: "Offer total", value: "₹4,198.95", bold: true },
  { label: "Payable today (verification deposit)", value: "₹5", highlight: true },
  { label: "Balance at the sanctuary", value: "₹4,193.95" },
];

export default function PriceBreakdown() {
  return (
    <section id="pricing" data-testid={TEST_IDS.priceSection} className="py-20 sm:py-28 bg-[#171310]">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.7 }}>
            <p className="text-xs uppercase tracking-[0.2em] font-semibold text-[#f2cf8b] mb-3">Transparent Pricing</p>
            <h2 className="font-serif text-3xl sm:text-4xl lg:text-[46px] font-semibold text-[#f8f0df] tracking-tight mb-5 leading-tight">
              One price. <em className="italic text-[#bdb3a4]">No surprises.</em>
            </h2>
            <p className="text-base text-[#bdb3a4] leading-relaxed mb-8 max-w-md">
              The full session is ₹3,999 + 5% GST. Pay only <strong className="text-[#f2cf8b]">₹5 today</strong> as a refundable verification deposit. The remaining ₹4,193.95 is payable at the sanctuary.
            </p>
            <div className="space-y-4 max-w-md">
              <div className="flex items-center gap-3 p-4 rounded-xl bg-[rgba(57,196,122,0.06)] border border-[rgba(57,196,122,0.25)]">
                <Shield className="w-5 h-5 text-[#39c47a] shrink-0" />
                <p className="text-sm text-[#cfe9db] leading-relaxed">
                  <strong className="text-white">₹5 is fully refundable</strong> — The verification deposit confirms your booking request is genuine and holds your preferred slot queue.
                </p>
              </div>
              <div className="p-4 rounded-xl bg-[rgba(215,168,92,0.06)] border border-[rgba(215,168,92,0.2)]">
                <p className="text-sm text-[#f2cf8b] font-semibold mb-1">Why ₹5?</p>
                <p className="text-xs text-[#bdb3a4] leading-relaxed">
                  The ₹5 verification deposit confirms your booking request is genuine and holds your preferred slot queue. It is refundable as per the offer terms — no hidden checkout fee.
                </p>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ delay: 0.15, duration: 0.7 }}
            className="bg-gradient-to-b from-[#1b1510] to-[#120f0d] border border-[rgba(242,207,139,0.18)] rounded-2xl p-6 sm:p-8 shadow-[0_24px_80px_rgba(0,0,0,0.45)] max-w-md mx-auto lg:ml-auto">
            <h3 className="font-serif text-2xl font-semibold text-[#f8f0df] mb-6">Price Breakdown</h3>
            {lines.map((line, i) => (
              <div key={i} className={`flex justify-between items-center py-4 ${i < lines.length - 1 ? "border-b border-[rgba(255,255,255,0.07)]" : ""}`}>
                <span className={`text-sm ${line.bold || line.highlight ? "font-semibold text-[#f8f0df]" : "text-[#bdb3a4]"}`}>{line.label}</span>
                <span className={
                  line.bold ? "font-black text-xl text-[#f8f0df]" :
                  line.highlight ? "font-black text-xl text-[#f2cf8b]" :
                  "font-semibold text-sm text-[#f8f0df]"
                }>{line.value}</span>
              </div>
            ))}
            <a href="#booking" className="mt-6 w-full inline-flex items-center justify-center gap-2 py-3.5 rounded-xl bg-gradient-to-r from-[#f1cb82] to-[#b77a31] text-[#1b1108] font-black text-sm shadow-lg shadow-[#d7a85c]/18 hover:shadow-xl transition-all">
              RESERVE ₹5
            </a>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
